/* istanbul ignore file */
import { boolean as codecBoolean, optional as codecOptional } from 'purify-ts/Codec';
import { utils as coreUtils } from '@codegrade/api-core';
import { parsers } from '@codegrade/utils';
const LoginLoginLinkDataParser = /* #__PURE__ */ parsers.object([
    [
        'confirmSessionTermination',
        /* #__PURE__ */ codecOptional(codecBoolean),
        'confirm_session_termination',
    ],
]);
export class LoginLoginLinkData extends /* #__PURE__ */ coreUtils.AssigningBase {
    static decode(input) {
        return LoginLoginLinkDataParser.decode(input).map(res => new LoginLoginLinkData(res));
    }
    static unsafeDecode(input) {
        return LoginLoginLinkData.decode(input).unsafeCoerce();
    }
    static encode(data) {
        return LoginLoginLinkDataParser.encode(data);
    }
    static schema() {
        return LoginLoginLinkDataParser.schema();
    }
}
